/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_BuscadorPersona as BuscadorPersona,
  rec_Componente_vA_118_65 as Componente_vA_118_65,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorFecha as SelectorFecha,
  rec_api as api,
  rec_dS as dS,
  rec_ii as ii,
  rec_obtenerUsuario as obtenerUsuario,
  rec_yA as yA,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function TransferirTrabajo({
  persona: e,
  onClose: t,
  onHecho: n,
  yaSeFue: r = !1,
}) {
  let { confirmar: i } = Fo(),
    [a, o] = (0, React.useState)(null),
    [s, c] = (0, React.useState)(``),
    [l, u] = (0, React.useState)(null),
    [f, p] = (0, React.useState)(`mismo`),
    [m, h] = (0, React.useState)(null),
    [g, _] = (0, React.useState)(``),
    [v, y] = (0, React.useState)(dS(new Date())),
    [b, x] = (0, React.useState)(``),
    [S, C] = (0, React.useState)(!1),
    w = (0, React.useCallback)(async () => {
      c(``);
      try {
        o(await api(`/personal/${e.usuarioId}/baja`));
      } catch (e) {
        c(e.message);
      }
    }, [e.usuarioId]);
  (0, React.useEffect)(() => {
    w();
  }, [w]);
  let T = r ? `Lo que dejó ${e.nombre}` : `Baja de ${e.nombre}`,
    E = a?.cargos ?? [],
    D = f === `mismo` ? l : f === `otro` ? m : null;
  async function O(t) {
    if ((t.preventDefault(), !l)) {
      x(`Elegí quién sigue con sus pendientes.`);
      return;
    }
    if (E.length && f === `otro` && !m) {
      x(`Elegí quién toma su cargo.`);
      return;
    }
    let a = [`Sus pendientes pasan a ${l.nombre}`];
    if (
      (E.length &&
        a.push(D ? `su cargo lo toma ${D.nombre}` : `su cargo queda vacante`),
      await i({
        titulo: r
          ? `Pasar lo que dejó ${e.nombre}`
          : `Dar de baja a ${e.nombre}`,
        mensaje: r
          ? `${a.join(`, `)}.`
          : `${a.join(`, `)}. Se le cierran las sesiones.`,
        confirmarTexto: r ? `Pasar` : `Dar de baja`,
        peligro: !0,
      }))
    ) {
      (C(!0), x(``));
      try {
        n(
          await api(`/personal/${e.usuarioId}/${r ? `traspaso` : `baja`}`, {
            method: `POST`,
            body: JSON.stringify({
              aUsuarioId: l.id,
              aNombre: l.nombre,
              aCorreo: l.correo,
              ...(E.length && D
                ? {
                    cargoUsuarioId: D.id,
                    cargoNombre: D.nombre,
                    cargoCorreo: D.correo,
                  }
                : {}),
              cargoVacante: !!E.length && !D,
              motivo: g,
              fecha: v,
              actorNombre: obtenerUsuario()?.nombre,
            }),
          }),
        );
      } catch (e) {
        (x(e.message), C(!1));
      }
    }
  }
  if (s)
    return (
      <Modal
        titulo={T}
        onClose={t}
        children={<EstadoError mensaje={s} onReintentar={w} />}
      />
    );
  if (!a)
    return (
      <Modal
        titulo={T}
        onClose={t}
        children={
          <p
            className={`flex items-center gap-2 text-sm text-(--text)`}
            children={[
              (0, JSXRuntime.jsx)(ii, {
                className: `h-4 w-4 animate-spin`,
              }),
              ` Revisando lo que deja abierto…`,
            ]}
          />
        }
      />
    );
  let k = [
    yA(a.abiertas, `tarea asignada`, `tareas asignadas`),
    a.encargos > 0 &&
      `${yA(a.encargos, `tarea que encargó`, `tareas que encargó`)}${a.porAprobar ? ` (${a.porAprobar} esperando su visto bueno)` : ``}`,
    a.proyectos > 0 &&
      yA(a.proyectos, `proyecto que administra`, `proyectos que administra`),
  ].filter(Boolean);
  return (
    <Modal
      titulo={T}
      onClose={t}
      children={
        <form
          onSubmit={O}
          className={`flex flex-col gap-3 text-sm`}
          children={[
            <div
              className={`rounded-2xl bg-(--panel) px-3 py-2 text-(--text)`}
              children={[
                <p
                  className={`font-medium text-(--text-h)`}
                  children={r ? `Dejó abierto` : `Deja abierto`}
                />,
                <ul
                  className={`mt-1 list-disc pl-5`}
                  children={k.map((e) => (
                    <li key={e} children={e} />
                  ))}
                />,
              ]}
            />,
            <p
              className={`font-medium text-(--text-h)`}
              children={`¿Quién sigue con sus pendientes?`}
            />,
            l ? (
              <Componente_vA_118_65 persona={l} onQuitar={() => u(null)} />
            ) : (
              <BuscadorPersona
                placeholder={`Buscar a quién le pasan…`}
                excluirIds={[e.usuarioId]}
                onSelect={u}
              />
            ),
            E.length > 0 && (
              <fieldset
                className={`flex flex-col gap-2`}
                children={[
                  <legend
                    className={`mb-1 font-medium text-(--text-h)`}
                    children={`¿Quién toma su cargo?`}
                  />,
                  <ul
                    className={`flex flex-col gap-1 text-(--text)`}
                    children={E.map((e) => (
                      <li
                        key={e.unidadId}
                        children={[
                          <strong
                            className={`text-(--text-h)`}
                            children={e.cargo}
                          />,
                          ` · `,
                          e.unidad,
                        ]}
                      />
                    ))}
                  />,
                  [
                    [
                      `mismo`,
                      l
                        ? `La misma persona (${l.nombre})`
                        : `La misma persona que sigue con los pendientes`,
                    ],
                    [`otro`, `Otra persona`],
                    [`vacante`, `Queda vacante por ahora`],
                  ].map(([e, t]) => (
                    <label
                      key={e}
                      className={`flex min-h-11 cursor-pointer items-center gap-2 rounded-xl px-2 hover:bg-(--accent-bg)`}
                      children={[
                        <input
                          type={`radio`}
                          name={`cargo`}
                          value={e}
                          checked={f === e}
                          onChange={() => p(e)}
                          className={`accent-(--accent)`}
                        />,
                        <span className={`text-(--text-h)`} children={t} />,
                      ]}
                    />
                  )),
                  f === `otro` &&
                    (m ? (
                      <Componente_vA_118_65
                        persona={m}
                        onQuitar={() => h(null)}
                      />
                    ) : (
                      <BuscadorPersona
                        placeholder={`Buscar quién toma el cargo…`}
                        excluirIds={[e.usuarioId]}
                        onSelect={h}
                      />
                    )),
                  f === `vacante` && (
                    <p
                      className={`text-xs text-(--text)`}
                      children={`Mientras tanto, lo de su equipo lo ve quien está por encima.`}
                    />
                  ),
                ]}
              />
            ),
            !r && (
              <div
                className={`grid gap-2 sm:grid-cols-2`}
                children={[
                  <SelectorFecha
                    value={v}
                    placeholder={`Fecha de salida`}
                    onChange={y}
                  />,
                  <input
                    className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                    placeholder={`Motivo (opcional)`}
                    value={g}
                    onChange={(e) => _(e.target.value)}
                  />,
                ]}
              />
            ),
            b && <p className={`text-(--error)`} children={b} />,
            <div
              className={`flex flex-col-reverse gap-2 sm:flex-row sm:justify-end`}
              children={[
                <button
                  type={`button`}
                  onClick={t}
                  className={zo}
                  children={`Volver`}
                />,
                <button
                  type={`submit`}
                  disabled={S}
                  className={Ro}
                  children={[
                    S &&
                      (0, JSXRuntime.jsx)(ii, {
                        className: `mr-1 inline h-4 w-4 animate-spin`,
                      }),
                    ` `,
                    r ? `Pasar` : `Dar de baja`,
                  ]}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
